module.exports = __webpack_public_path__ + "static/thumb-placeholder-1098715e4d50f88e8a006576b90e3769.png";